import { api } from '@/routes/shared/_api'
import { AllAccountTypes } from './schema'

/**
 * Creates a new ownership account (standalone, not associated with an investment)
 * @param data - Account data matching one of the account type schemas
 * @returns The created account object
 */
export const createAccount = async (data: Partial<AllAccountTypes>) => {
  const response = await api.post('/dashboard/investment-accounts/', data)
  return response
}
